import {
  CalendarOutlined,
  CarOutlined,
  DashboardOutlined,
  EyeOutlined,
  FileTextOutlined,
  GlobalOutlined,
  LinkOutlined,
  MailOutlined,
  PhoneOutlined,
  PlusOutlined,
  SendOutlined,
  UserOutlined,
} from "@ant-design/icons";
import type { ReactNode } from "react";

export const iconMap: Record<string, ReactNode> = {
  send: <SendOutlined />,
  global: <GlobalOutlined />,
  link: <LinkOutlined />,
  file: <FileTextOutlined />,
  fileText: <FileTextOutlined />,
  car: <CarOutlined />,
  user: <UserOutlined />,
  eye: <EyeOutlined />,
  mail: <MailOutlined />,
  phone: <PhoneOutlined />,
  calendar: <CalendarOutlined />,
  dashboard: <DashboardOutlined />,
  plus: <PlusOutlined />,
};

/**
 * Returns the configured icon for an action, or null when none is configured
 * or the configured name is unknown. Use this when an icon is optional.
 */
export function getActionIcon(icon?: string): ReactNode | null {
  return icon != null ? (iconMap[icon] ?? null) : null;
}

/**
 * Always returns an icon, falling back to a neutral link icon when no specific
 * icon is configured. Use this when an icon is always rendered (e.g. action
 * tiles). The icon is purely config-driven (`action.icon`); it is never
 * derived from whether the action is external.
 */
export function resolveActionIcon(icon?: string): ReactNode {
  return getActionIcon(icon) ?? <LinkOutlined />;
}
